import * as React from 'react';
import Link from 'next/link'
import { useRouter } from 'next/router'
import { css } from "@emotion/react"
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { useSelector, useDispatch } from 'react-redux'
import { useEffect } from 'react'
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import LaunchIcon from '@material-ui/icons/Launch';
import TopIcon from '../../../../../public/images/common/menu-top.svg'
import TeikiIcon from '../../../../../public/images/common/menu-omakase.svg'
import CatalogIcon from '../../../../../public/images/common/menu-catalog.svg'
import ItemIcon from '../../../../../public/images/common/menu-products.svg'
import MypageIcon from '../../../../../public/images/common/menu-mypage.svg'

// actions
import { toggleDrawer } from '~/slices/commons/drawer'
import {login, logout} from '~/slices/logins/index'
import { SubmitLogout } from '~/api/login'

// components
import {
  Box,
  Drawer,
  Button,
  List,
  Divider,
  ListItem } from '@material-ui/core';

// resource
import { mainMenuList, subMenuList, otherMenuList } from '~/data/common/headerMenu'
import {useTheme} from "@material-ui/core/styles";
import {makeStyles} from "@material-ui/styles";
import Container from "@material-ui/core/Container";
import {useWindowDimensions} from "../../../../services/hooks/common";

export default function MenuDrawer(props) {
  const signIn = useSelector((state) => state.login.login)
  const { width, height } = useWindowDimensions();

  const theme = useTheme()
  const useStyles = makeStyles({
    drawerPaper: {
      maxHeight: '90vh !important',
      [theme.breakpoints.up('md')]: {
        width: '360px',
        left: 'auto !important',
        right: 0
      },
      [theme.breakpoints.up('lg')]: {
        width: '360px',
        left: 'auto !important',
        right: `${width <= 960 ? 0 : 'calc((100vw - 960px)/2)'} !important`
      },
    },
  })

  const classes = useStyles()
  const { openFlg, key } = useSelector((state) => state.drawer)
  const dispatch = useDispatch()
  const router = useRouter()
  // storeのリセット
  const resetBtn = () => {
    dispatch({type: 'STORE_RESET'})
  }
  const customerState = useSelector((state) => state.customer)
  const handleLogout = async(e) => {
    e.preventDefault();
    await dispatch(SubmitLogout(customerState.info.id));
  }

  return (
      <div>
        <Drawer
            anchor={'top'}
            open={openFlg && key == 'main'}
            onClose={() => dispatch(toggleDrawer({openFlg: false, key: 'main'}))}
            css={position}
            classes={{paper: classes.drawerPaper}}
        >
          <Container>
            <Box
                sx={{ width: 'auto' }}
                role="presentation"
                //onKeyDown={() => dispatch(toggleDrawer({openFlg: false, key: 'main'}))}
                css={props.isSpacer ? marginTopAddSpacer : marginTop}
            >
              <List>
                {mainMenuList.map((obj, index) => (
                    <Link href={obj.path} prefetch={obj.prefetch} key={index}>
                      <a>
                        <Box key={obj.path}>
                          {
                            (obj.title === 'トップページ' && !signIn || obj.title === 'マイページ' && signIn || obj.title !== 'マイページ' && obj.title !== 'トップページ') &&
                            <ListItem
                                button
                                onClick={() => dispatch(toggleDrawer({openFlg: false, key: 'main'}))}
                                css={{padding:'0.5rem 0'}}
                            >
                              <ListItemIcon css={[iconStyle, {minWidth: 0, marginRight: '0.5rem'}]}>
                                { obj.title === 'トップページ' && <TopIcon/> }
                                { obj.title === 'マイページ' && <MypageIcon/> }
                                { obj.title === '商品一覧' && <ItemIcon/> }
                                { obj.title === '栄養士おまかせ定期便' && <TeikiIcon/> }
                                { obj.title === 'カタログ' && <CatalogIcon/> }
                              </ListItemIcon>
                              <div css={label}>
                                <ListItemText primary={obj.title} />
                              </div>
                            </ListItem>
                          }
                        </Box>
                      </a>
                    </Link>
                ))}
              </List>
              <Divider />
              <List>
                {subMenuList.map((obj, index) => (
                    <ListItem
                        button key={index}
                        onClick={() => dispatch(toggleDrawer({openFlg: false, key: 'main'}))}
                        css={{padding:'2px 0'}}
                    >
                      <ListItemIcon css={{minWidth: 0, marginRight: '0.5rem'}}>
                        <ArrowRightIcon color={'primary'}/>
                      </ListItemIcon>
                      {
                        obj.outer &&
                        <a href={obj.path} rel={"noreferrer"} target={'_blank'} css={linkLabel}>
                          <div css={{display: 'flex', alignItems: 'center'}}>
                            <ListItemText primary={obj.title} />
                            <LaunchIcon color={'primary'} css={{width: '1.6rem', margin: '0 0.5rem'}}/>
                          </div>
                        </a>
                        ||
                        obj.prefetch &&
                        <Link href={obj.path}>
                          <a css={linkLabel}>
                            <ListItemText primary={obj.title} />
                          </a>
                        </Link>
                        ||
                        <Link href={obj.path} prefetch={obj.prefetch}>
                          <a css={linkLabel}>
                            <ListItemText primary={obj.title} />
                          </a>
                        </Link>
                      }
                    </ListItem>
                ))}
              </List>
              <Divider />
              <List>
                {otherMenuList.map((obj, index) => (
                  ((obj.path === '/logout' && signIn) || (obj.path !== '/logout')) &&
                    <ListItem
                        button key={index}
                        onClick={() => dispatch(toggleDrawer({openFlg: false, key: 'main'}))}
                        css={{padding: '0'}}
                    >
                      <ListItemIcon css={{minWidth: 0, marginRight: '0.5rem'}}>
                        <ArrowRightIcon color={'primary'}/>
                      </ListItemIcon>
                      {
                        obj.outer &&
                        <a href={obj.path} rel={"noreferrer"} target={'_blank'} css={linkLabel}>
                          <div css={{display: 'flex', alignItems: 'center'}}>
                            <ListItemText primary={obj.title} />
                            <LaunchIcon color={'primary'} css={{width: '1.6rem', margin: '0 0.5rem'}}/>
                          </div>
                        </a>
                        ||
                        obj.prefetch &&
                        <Link href={obj.path}>
                          <a css={linkLabel}>
                            <ListItemText primary={obj.title} />
                          </a>
                        </Link>
                        ||
                        (obj.path == '/logout') &&
                        <ListItemText
                          primary={obj.title}
                          css={linkLabel}
                          onClick={(e) => handleLogout(e)}
                        />
                        ||
                        <Link href={obj.path} prefetch={obj.prefetch}>
                          <a css={linkLabel}>
                            <ListItemText primary={obj.title} />
                          </a>
                        </Link>
                      }
                    </ListItem>
                ))}
              </List>
              {/*<Button onClick={resetBtn}>*/}
              {/*  Reset*/}
              {/*</Button>*/}
              {/*<div>*/}
              {/*  <Button*/}
              {/*      type="submit"*/}
              {/*      variant="outlined"*/}
              {/*      onClick={() => dispatch(login())}>*/}
              {/*    <strong>*/}
              {/*      ログイン*/}
              {/*    </strong>*/}
              {/*  </Button>*/}
              {/*  <Button*/}
              {/*      type="submit"*/}
              {/*      variant="outlined"*/}
              {/*      onClick={() => dispatch(logout())}>*/}
              {/*    <strong>*/}
              {/*      ログアウト*/}
              {/*    </strong>*/}
              {/*  </Button>*/}
              {/*</div>*/}
            </Box>
          </Container>
        </Drawer>
      </div>
  );
}

const position = css`
    z-index: 99;
  `

const marginTop = css`
    padding-top: 70px;
  `

const marginTopAddSpacer = css`
  padding-top: 112px;
`

const iconStyle = css`
  svg {
    width: 3rem;
  }
`

const label = css`
  margin-left: 0.5rem;
  span {
    font-weight: 500;
    font-size: 1.6rem;
  }
`

const linkLabel = css`
  span {
    font-weight: 500;
  }
`
